"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyText = exports.TitleText = exports.BannerContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.BannerContainer = native_1.default.View `
  padding: 16px 24px 14px;
  border: solid 1px #dfdfdf;
`;
exports.TitleText = native_1.default.Text `
  font-size: 18px;
  letter-spacing: 1px;
  color: #111111;
`;
exports.BodyText = native_1.default.Text `
  margin-top: 12px;
  margin-bottom: 16px;
  font-family: 'Roboto';
  font-size: 14px;
  letter-spacing: 0.7px;
  line-height: 20px;
  color: rgba(17, 17, 17, 0.8);
`;
